import { FC } from "react";

import { PDF_WIDTH } from "@src/features/libraryItem/course/ClickablePdfPreview";

const CHIP_SIZE = 50;
const SCALE = CHIP_SIZE / PDF_WIDTH;

type Props = {
  mediaUrl: string;
};

const PdfChipPreview: FC<Props> = ({ mediaUrl }) => (
  <div className="pointer-events-none size-full overflow-hidden rounded-lg bg-gray-2">
    <iframe
      src={`${mediaUrl}#toolbar=0&navpanes=0&scrollbar=0`}
      title="PDF"
      className="border-0 outline-none"
      style={{
        width: PDF_WIDTH,
        aspectRatio: "128 / 180",
        transform: `scale(${SCALE})`,
        transformOrigin: "top left",
      }}
    />
  </div>
);

export default PdfChipPreview;
